module.exports = __webpack_public_path__ + "static/media/post-02.1e76a2c7.jpg";